module.exports = __webpack_public_path__ + "static/img/bg1.8be7485.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/skin/bg1.png
// module id = jT76
// module chunks = 0